import { defaultSettings } from '../constants';

export const settingsReducer = (state, action) => {
  switch (action.type) {
    case 'setFilters':
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case 'setBootstrap':
      return { ...state, bootstrap: { ...state.bootstrap, ...action.payload } };
    case 'setChart':
      return { ...state, chart: { ...state.chart, ...action.payload } };
    case 'setForest':
      return { ...state, forest: { ...state.forest, ...action.payload } };
    case 'setHighRes':
      return { ...state, highRes: { ...state.highRes, ...action.payload } };
    case 'setRecommend':
      return { ...state, recommend: { ...state.recommend, ...action.payload } };
    case 'loadSettings':
      return { ...state, ...action.payload };
    case 'resetSettings':
      return { ...defaultSettings };
    case 'triggerRun':
      return { ...state, meta: { ...state.meta, runTrigger: Date.now() } };
    default:
      return state;
  }
};
